export const EXPERIENCE_CONTENT_TAB = 'experience';
export const ORIGINAL_EXPERIENCE_CONTENT_TAB = 'original-experience';
